export default __webpack_public_path__ + "static/merchant-payment-services-company-peerbits-e383d57674e18b06006cbab88f0af985.png";